// Admin-only route guard. Layered on top of RequireAuth — non-admin users
// land on /projects with a flash. Real authorization is server-side
// (every /api/admin/* endpoint checks `is_admin` via _require_admin
// dependency), this is just UX so non-admins never see a half-broken page.

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getStoredUser } from '../lib/auth';
import type { User } from '../types/api';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const user = getStoredUser<User>();
  if (!user?.is_admin) {
    return <Navigate to="/download" replace />;
  }
  return <>{children}</>;
}
